/**
 * @file useRecruitmentFacade.hook.ts
 * @path apps/website/src/features/recruitment/hooks/useRecruitmentFacade.hook.ts
 */
import { useProcessState } from "./useProcessState.hook";
import { usePositionsState } from "./usePositionsState.hook";
import { useApplicationForm } from "./useApplicationForm.hook";

export const useRecruitmentFacade = () => {
  const process = useProcessState();
  const positions = usePositionsState();
  const application = useApplicationForm();

  return {
    positions: {
      data: positions.vacancies,
      openId: positions.openId,
      actions: {
        toggleAccordion: positions.toggleAccordion,
        openApplication: application.actions.openApplication,
      },
    },
    application: {
      form: application.form,
      dialogJob: application.dialogJob,
      fileState: { file: application.cvFile, error: application.fileError },
      submissionState: {
        isSubmitting: application.isSubmitting,
        isSuccess: application.isSuccess,
      },
      actions: {
        submit: application.actions.submitApplication,
        handleFileChange: application.actions.handleFileChange,
        removeFile: application.actions.removeFile,
        close: application.actions.closeApplication,
      },
    },
    process: {
      steps: process.steps,
      activeStepId: process.activeStepId,
      activeStep: process.activeStep,
      actions: {
        setActiveStepId: process.setActiveStepId,
      },
    },
  };
};
